/** Replace backslashes with forward slashes. */
export function slash(str: string): string {
  return str.replace(/\\/g, '/');
}
